<template>
<div  class="nutritionSettingstype">
     <div class="header">    
        <el-button size="medium" type="default" @click.native="$router.back()">返回</el-button>  
        <el-button type="primary" size="medium" @click="saveFoodTypeSets()">保存</el-button>
     </div>
     <div class="subject" :style="`height: ${windowHeight - 180}px;`">
         <div class="body">
            <el-table :data="datalist" border style="width: 100%">
                <el-table-column prop="foodTypeName" label="分类" align="center"></el-table-column>               
                <el-table-column  label="幼儿园（g）" align="center" >
                     <template slot-scope="scope">
                         <el-input-number size="mini" :precision="0" :step="1" :min="50" :max="1000" v-model="scope.row.kindergarten"></el-input-number>
                    </template>
                </el-table-column>              
                <el-table-column  label="小低（g）"  align="center">
                     <template slot-scope="scope">
                         <el-input-number size="mini" :precision="0" :step="1" :min="50" :max="1000" v-model="scope.row.smallLow"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="小高（g）"  align="center">
                     <template slot-scope="scope">
                         <el-input-number size="mini" :precision="0" :step="1" :min="50" :max="1000" v-model="scope.row.smallHeight"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label=" 初中（g）"  align="center">
                     <template slot-scope="scope">
                         <el-input-number size="mini" :precision="0" :step="1" :min="50" :max="1000" v-model="scope.row.juniorMiddleSchool"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label=" 高中（g）"  align="center">
                     <template slot-scope="scope">
                         <el-input-number size="mini" :precision="0" :step="1" :min="50" :max="1000" v-model="scope.row.highSchool"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
           
         </div>
     </div>
</div> 
</template>
<script>
import {foodTypeSet,saveFoodTypeSet} from "@/api/foodSetting";
import windowResize from "@/mixins/windowResize";
export default {
  name: "dataAnalysis",
  data() {
    return {
       datalist:[]
    };
  },
  mixins: [windowResize],
  created() {
     this.foodTypeSets();
  },
  methods: {
     foodTypeSets(){
       foodTypeSet()
        .then(res => {
          const data = res.data.data;
          this.datalist=data;
          console.log(data)
        }).catch(err => {});
     },
     saveFoodTypeSets(){
         for(let i=0;i<this.datalist.length;i++){
          if(!this.datalist[i].kindergarten){
            this.$message.error("请输入"+this.datalist[i].foodTypeName+"幼儿园摄入量");
            return;
           }
          if(!this.datalist[i].smallLow){
            this.$message.error("请输入"+this.datalist[i].foodTypeName+"小低摄入量");
            return;
           }
          if(!this.datalist[i].smallHeight){
            this.$message.error("请输入"+this.datalist[i].foodTypeName+"小高摄入量");
            return;
           }
          if(!this.datalist[i].juniorMiddleSchool){
            this.$message.error("请输入"+this.datalist[i].foodTypeName+"初中摄入量");
            return;
           }
          if(!this.datalist[i].highSchool){
            this.$message.error("请输入"+this.datalist[i].foodTypeName+"高中摄入量");
            return;
           }           
         }
          saveFoodTypeSet(this.datalist)
            .then(res => {
              const data = res.data;
              if (data.code == 200) {
                this.$message({
                  message: "保存成功！",
                  type: "success",
                  duration: 1000
                });
                this.$router.back()
              }
            })
            .catch(err => {});
     }
  }
};
</script>
<style lang="scss" scoped>
.nutritionSettingstype {
  padding: 12px;
  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid  #eee;
  }
  .subject{
      overflow: auto;
      .body{
          margin: 10px auto;
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/foodSetting/nutritionSettingstype.vue